import React from "react";
import { useTranslation } from "react-i18next";
import { useChangeEmailAddress } from "./useChangeEmailAddress";
import { useStyles } from "./change-email-address.styles";

const ChangeEmailAddress: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { status, message, onContinueToAccount } = useChangeEmailAddress();

  return (
    <div className={classes.container}>
      <span className={classes.title}>{t("auth.changeEmailTitle")}</span>
      <div className={classes.card}>
        <span className={`h6-regular ${classes.message}`}>{message}</span>
        <button
          type="button"
          className={classes.continueButton}
          disabled={status === "loading"}
          onClick={onContinueToAccount}
        >
          {t("auth.continueToAccount")}
        </button>
      </div>
    </div>
  );
};

export default ChangeEmailAddress;
